angular.module('rjmNg.common.api').factory('Google', [
  "$http"
  "$httpParamSerializerJQLike"
  "$q"
  "phpServiceUrl"
  (
    $http
    $httpParamSerializerJQLike
    $q
    phpServiceUrl
  ) ->

    (clientId, googleParams={}) ->

      getConnectionName = (profile, feature) ->
        # this is pretty long on the connections list page
        "Google #{feature}: #{profile.websiteUrl} #{profile.name}"

      getGA4ConnectionName = (profile, feature) ->
        # this is pretty long on the connections list page
        "Google Analytics 4 Live: #{profile.displayName} (#{profile.accountName})"

      getAccessToken = (code, feature) ->
        $http(
          method: 'POST'
          url: phpServiceUrl("/client/#{clientId}/google/token/")
          params: { code: code, feature: feature }
        )

      getProfileIds = (token) ->
        $http(
          method: 'GET'
          url: phpServiceUrl("/client/#{clientId}/google/profileIds/")
          params: { token: token }
        )

      getGA4ProfileIds = (token) ->
        $http(
          method: 'GET'
          url: phpServiceUrl("/client/#{clientId}/google/GA4ProfileIds/")
          params: { token: token }
        )

      save = (properties) ->
        $http.post(phpServiceUrl("/client/#{clientId}/google/"), properties)

      testConnection = (properties) ->
        $http.post(phpServiceUrl("/client/#{clientId}/google/testConnection"), properties)

      getValidProfileIds = (accessToken, refreshToken, feature) ->
        deferred = $q.defer()

        getProfileIds(accessToken).then (profileResponse) ->
          unless profileResponse.data?.items?.length > 0
            deferred.reject()
            return

          allProfiles = profileResponse.data.items

          if allProfiles.length is 0
            deferred.resolve
              profiles: []
              invalidProfiles: false
          else
            testPromises = allProfiles.map (profile) ->
              testDeferred = $q.defer()

              testPromise = testConnection
                token: refreshToken
                profileId: profile.id
                feature: feature

              testPromise.then (response) ->
                if response.data.containsRows
                  testDeferred.resolve(true)
                else
                  testDeferred.resolve(false)
              , () ->
                testDeferred.resolve false

              return testDeferred.promise

            $q.all(testPromises).then (profileValidity) ->
              validProfiles = allProfiles.filter (profile, index) ->
                profileValidity[index]

              deferred.resolve
                profiles: validProfiles
                invalidProfiles: allProfiles.length isnt validProfiles.length

        , deferred.reject

        return deferred.promise

      getAuthorizationUrl = (feature, connectionId) ->
        state = JSON.stringify
          clientId: clientId
          connectionIdToReauth: connectionId ? null

        queryParams =
          access_type: "offline"
          approval_prompt: "force"
          client_id: googleParams[feature].client_id
          feature: feature
          redirect_uri: "#{googleParams.redirectUrl}?feature=#{feature}"
          response_type: "code"
          scope: googleParams.scope
          state: state

        query = $httpParamSerializerJQLike(queryParams)
        return "https://accounts.google.com/o/oauth2/auth?#{query}"

      {
        getConnectionName
        getGA4ConnectionName
        getAccessToken
        getProfileIds
        save
        testConnection
        getAuthorizationUrl
        getValidProfileIds
        getGA4ProfileIds
      }
  ]
)
